export default {
  meta: {
    title: '拓店管理-开店计划管理',
  }
};
